angular.module('workflow.app')

.factory 'ManualSourceBreakdown', () ->

  # Private methods

  sourceIsDone = ( source ) ->
    return ( source.state == 'ignore' || source.state == 'complete' )

  sourceIsTodo = ( source ) ->
    return !sourceIsDone( source )

  class ManualSourceBreakdown

    constructor: ( sources ) ->
      @sources = sources

      @breakdown = {
        done: 0
        todo: 0
      }

      @refresh()

    refresh: () ->
      @breakdown.todo = 0
      @breakdown.done = 0

      for source in @sources
        if sourceIsDone(source)
          @breakdown.done++
        if sourceIsTodo(source)
          @breakdown.todo++

    getDoneCount: () ->
      @refresh()
      @breakdown.done

    getTodoCount: () ->
      @refresh()
      @breakdown.todo

    getAllCount: () ->
      @refresh()
      @sources.length

    allDone: () ->
      @breakdown.todo == 0
